import React from "react"
import types from "prop-types"
import { dynamicRangeSurveysExample, dayRangeSurveyInclusionDescription } from "utils/scheduledReportExportHelpers"

const DaysSubmissionDescription = ({ startDate, surveySentPreviousRangeLength = null }) => {
  const daysCount = surveySentPreviousRangeLength || 1

  const beginningDate = startDate.subtract(daysCount, "d")
  const endingDate = startDate.subtract(1, "d")

  return (
    <div className="text-xs text-dark mt-2">
      <p className="mb-4">
        {dayRangeSurveyInclusionDescription}
      </p>
      <p>
        {dynamicRangeSurveysExample({ startDate, beginningDate, endingDate })}
      </p>
    </div>
  )
}

DaysSubmissionDescription.propTypes = {
  startDate: types.object.isRequired,
  surveySentPreviousRangeLength: types.number,
}

export default DaysSubmissionDescription
